import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Loader from "./collaborators-select-loader";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import vSelectField from "@Shared/components/form-elements/fields/v-select-field.vue";
import { fullName } from "@Shared/@Utils/helpers/text";
import { isEmpty, cloneDeep } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "CollaboratorsSelect",
  components: {
    Loader,
    vSelectField,
    MaterialInput
  },
  props: {
    collaborators: {
      type: Array,
      required: true
    },
    value: {
      type: [Array, String],
      required: true
    },
    placeholder: {
      type: String,
      default: "Add or Remove Collaborators"
    },
    multiple: {
      type: Boolean,
      default: true
    },
    formGroupClass: {
      type: String,
      default: ""
    },
    containerClass: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedCollaborators: []
    };
  },
  computed: {
    selectContainerClass() {
      const cssClass = [];
      if (this.containerClass) {
        cssClass.push(this.containerClass.split(" "));
      } else {
        cssClass.push("mt-3");
      }
      return cssClass.join(" ");
    },
    groupClass() {
      const cssClass = this.formGroupClass.split(" ");
      cssClass.push("form-group-material");
      return cssClass.join(" ");
    },
    emptyCollaborators() {
      return _Object$keys(this.collaborators).length === 0;
    },
    vSelectCollaboratorsOptions() {
      var _context;
      return _mapInstanceProperty(_context = this.collaborators).call(_context, collaborator => {
        return _objectSpread({
          label: fullName(collaborator),
          fullName: fullName(collaborator)
        }, collaborator);
      });
    },
    vSelectDefaultValue() {
      var _context2;
      return _findInstanceProperty(_context2 = this.vSelectCollaboratorsOptions).call(_context2, collaborator => collaborator.username === this.value);
    }
  },
  methods: {
    formatData(data) {
      data = cloneDeep(data);
      return data && _mapInstanceProperty(data).call(data, ref => {
        ref.id = ref.username;
        ref.text = `${ref.givenName} ${ref.familyName}`;
        return ref;
      });
    },
    handleChange(data, type) {
      if (!this.multiple) this.$emit("change", data, type);
      if (type === "select") {
        this.selectedCollaborators.push(data);
      } else if (type === "unselect") {
        var _context3;
        this.selectedCollaborators = _filterInstanceProperty(_context3 = this.selectedCollaborators).call(_context3, collaborator => collaborator.username !== data.username);
      }
    },
    handleClose() {
      this.$emit("close", this.selectedCollaborators);
      this.selectedCollaborators = [];
    },
    matchCustom(params, data) {
      var _params$term$toLowerC, _params$term, _data$text$toLowerCas, _data$text, _data$email$toLowerCa, _data$email, _context4;
      const term = (_params$term$toLowerC = params == null ? void 0 : (_params$term = params.term) == null ? void 0 : _params$term.toLowerCase()) != null ? _params$term$toLowerC : "";
      const isTermEmpty = isEmpty(_trimInstanceProperty(term).call(term));
      if (isTermEmpty) return data;
      const name = (_data$text$toLowerCas = (_data$text = data.text) == null ? void 0 : _data$text.toLowerCase()) != null ? _data$text$toLowerCas : "";
      const email = (_data$email$toLowerCa = (_data$email = data.email) == null ? void 0 : _data$email.toLowerCase()) != null ? _data$email$toLowerCa : "";
      if (_includesInstanceProperty(_context4 = `${name} ${email}`).call(_context4, term)) return data;
      return null;
    }
  }
});